interface RecordAccessDeniedNoticeProps {
  /** 403 renders "Access denied"; anything else (404) renders "Record not found". */
  statusCode: number | undefined;
}

// Shown in place of RecordBody when the record can't be resolved: access
// denied (403 always) or not found (404, unless a pending optimistic
// creation — see usePendingCreation404Recovery in the caller).
export function RecordAccessDeniedNotice({
  statusCode,
}: RecordAccessDeniedNoticeProps) {
  return (
    <div className='p-6'>
      <div className='p-4 bg-utility-warning-50 border border-utility-warning-200 rounded-xl'>
        <div className='flex items-center gap-3'>
          <svg
            className='w-5 h-5 text-utility-warning-600'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
            />
          </svg>
          <p className='text-utility-warning-900 font-medium'>
            {statusCode === 403 ? 'Access denied' : 'Record not found'}
          </p>
        </div>
      </div>
    </div>
  );
}
